export const environment = {
  production: false,
  bankIdUrl: 'https://bankid-daniel.legitimera.akiru.se/service',
  apiUrl: 'https://id-backend-daniel.legitimera.akiru.se/api'
}
